import { ProductOrderItem } from "@/api/models/product_order/ProductOrder";

export const countImage = (imageUrl: Array<string>): number => {
  if (imageUrl === undefined || imageUrl === null) {
    return 0;
  }
  if (imageUrl.length <= 1) {
    return 0;
  }
  return (imageUrl.length - 1) * 2;
};

export const countProduct = (products: Array<ProductOrderItem>) => {
  if (products === undefined || products === null) {
    return 0;
  }
  let count = 0;
  products.forEach((product, _) => {
    count += product.num * (product.price + product.fright);
  });
  return count;
};
